export enum MessageType {
  TEAM_CHAT = 'hub',
  OPEN_CHAT = 'open-chat',
  OPEN_FORUM = 'open-forum',
}
